import { render, staticRenderFns } from "./ReviseDept.vue?vue&type=template&id=1a9969f1&"
import script from "./ReviseDept.vue?vue&type=script&lang=js&"
export * from "./ReviseDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports